



























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class SelectFontesPagadoras extends Vue {
  /** Ids das fontes selecionadas (v-model). */
  @Prop({ default: () => [] }) value!: string[]
  /** Fontes que o usuário tem permissão de ver — "Todos" nunca vai além desta lista. */
  @Prop({ default: () => [] }) items!: any[]
  @Prop({ default: 'Fonte Pagadora' }) label!: string
  @Prop({ default: () => [] }) rules!: any[]

  get selecionadas(): string[] {
    return this.value || []
  }

  get icon() {
    if (this.items.length > 0 && this.selecionadas.length === this.items.length) return 'mdi-checkbox-marked'
    if (this.selecionadas.length > 0) return 'mdi-minus-box'
    return 'mdi-checkbox-blank-outline'
  }

  isSelecionada(item: any) {
    return this.selecionadas.includes(item.id)
  }

  toggle(item: any) {
    const selecionadas = this.isSelecionada(item)
      ? this.selecionadas.filter(id => id !== item.id)
      : [...this.selecionadas, item.id]

    this.emitir(selecionadas)
  }

  selectAll() {
    const selecionadas = this.selecionadas.length === this.items.length
      ? []
      : this.items.map(item => item.id)

    this.emitir(selecionadas)
  }

  emitir(value: string[]) {
    this.$emit('input', value)
  }
}
